import { fromApiDate } from 'src/helpers';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';

export type ICustomerLeadProductResponse = Pick<
  ICustomerLeadProduct,
  | 'id'
  | 'ticketNumber'
  | 'companyName'
  | 'shippingAddress'
  | 'billingAddress'
  | 'contacts'
  | 'productTypeId'
  | 'initialQty'
  | 'specData'
  | 'submittedFieldGroups'
  | 'purchaseProductTypes'
  | 'customerPickup'
  | 'exempt'
  | 'purchaseFrequency'
  | 'purchaseFrequencyQty'
  | 'urgency'
  | 'maxQtySingleDelivery'
  | 'purchaseReasons'
  | 'contractPricing'
  | 'additionalInfo'
  | 'salesTaxFiles'
> & {
  accessedAt: string;
};

export function fromApiCustomerLeadProductResponse(response: ICustomerLeadProductResponse): ICustomerLeadProduct {
  return {
    ...response,

    accessedAt: fromApiDate(response.accessedAt),
  };
}
